export const questionnaireError = (state) => state.error;
export const questionnaireLead = (state) => state.questionnaireLead;
export const curMode = (state) => state.mode;
export const curLeadWizard = (state) => state.leadWizard;
export const stepDetails = (state) => state.stepDetails;
export const stepDetailError = (state) => state.stepDetailError;
